import Api from 'services/api'
import { SET_AMAZON_SELLER_ACCOUNTS_DATA } from 'constants/action_types/amazon_seller_accounts'
import * as ACCOUNT_ACTIONS from '../../constants/action_types/accounts'
import { createNotification } from '../notifications'

export const mwsSyncGetStatus = () => async (dispatch, getState) => {
  dispatch({
    type:
      ACCOUNT_ACTIONS.ACCOUNT_AMAZON_SELLER_ACCOUNT_GET_STATUS_PENDING_STATUS
  })

  const sellerId = getState().globalData.user.id

  const res = await Api.getAmazonSellerAccountStatus(sellerId)

  if (res.ok) {
    dispatch({
      type: ACCOUNT_ACTIONS.ACCOUNT_AMAZON_SELLER_ACCOUNT_GET_STATUS_COMPLETE,
      payload: res.data
    })
  } else {
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Failed to fetch amazon seller account status'
      })
    )
  }

  dispatch({
    type:
      ACCOUNT_ACTIONS.ACCOUNT_AMAZON_SELLER_ACCOUNT_GET_STATUS_COMPLETE_STATUS,
    payload: {
      success: res.ok
    }
  })

  return res.ok
}

export const getAmazonSellerAccounts = () => async dispatch => {
  const res = await Api.getAmazonSellerAccounts()

  if (res.ok) {
    dispatch({
      type: SET_AMAZON_SELLER_ACCOUNTS_DATA,
      payload: {
        amazonSellerAccounts: res.data,
        sellerDataAvailable: true
      }
    })
  }
}

export const getAmazonMarketplacesList = () => async dispatch => {
  const res = await Api.getAmazonMarketplacesList()

  if (res.ok) {
    dispatch({
      type: ACCOUNT_ACTIONS.ACCOUNT_MARKETPLACE_LIST_LOAD_COMPLETE,
      payload: res.data
    })
  } else {
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Failed to load amazon seller account marketplaces'
      })
    )
  }
}

export const mwsSyncCloseStatusBar = () => (dispatch, getState) => {
  dispatch({
    type: ACCOUNT_ACTIONS.ACCOUNT_AMAZON_SELLER_ACCOUNT_CLOSE_STATUS_BAR
  })

  const state = getState()
  const sellerId = state.globalData.user.id
  const amazonSellerAccount =
    state.amazonSellerAccounts.amazonSellerAccounts.find(
      account => account.display_sync_status
    ) || {}

  // we don't really care if this fails, worst case scenario the bar appears next time they re-load the page
  // there's no positive action we need to take, so just fire & forget
  Api.patchDismissStatusBar(sellerId, amazonSellerAccount.id)
}

export const mwsSyncToggleDetailsModal = () => dispatch => {
  dispatch({
    type:
      ACCOUNT_ACTIONS.ACCOUNT_AMAZON_SELLER_ACCOUNT_TOGGLE_SYNC_DETAILS_MODAL
  })
}
